module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5770-bijuterias-acessorios.02b7c316.jpg";